// YERİ: src/app/core/i18n/stripe-locale.ts

/**
 * Stripe's language code, derived from the app/visitor language.
 *
 * MUST be handed to BOTH `Stripe(key, { locale })` and `elements({ locale })`.
 * Without it the card form ("Card number", "Expiration date") AND Stripe's own
 * validation errors ("Your card number is incomplete.") come up in English on a
 * Turkish page — the field labels are rendered inside Stripe's iframe, so no
 * amount of translation on our side reaches them.
 *
 * The raw code is passed through: Stripe falls back to English on a code it
 * does not know instead of failing, so the only thing worth trimming is the
 * region suffix ('en-ca' -> 'en').
 */
export function stripeLocale(lang: string | null | undefined): string {
  return (lang || 'tr').toLowerCase().split('-')[0];
}
